import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

export const CTAButtonWrapper = withViewportStyle("div")`
  margin: ${rem(24)} auto 0;
  width: max-content;
  max-width: ${rem(300)};

  ${(props) => props.$viewport.mobile`
    width: 100%;
    max-width: 100%;
  `}
`;

export const Content = styled.div`
  .text-primitive {
    text-align: center;
  }
`;

export const TextWrapper = withViewportStyle("div")`
  margin-top: ${rem(40)};
  padding: 0 ${rem(104)};

  ${(props) => props.$viewport.tablet`
    padding: 0 ${rem(52)};
  `}

  ${(props) => props.$viewport.mobile`
    padding: 0;
  `}
`;
